angular.module('SpidApp')

.controller('PasswordController', ['$scope', 'Toaster', 'UserService', 'LoginService', '$state', function ($scope, Toaster, UserService, LoginService, $state) {
    $scope.form = {
          oldPassword : null
        , newPassword : null
    }
    
    if ($scope.user.n === 1) {
        Toaster.danger("C'est votre dernière chance de changer votre mot de passe")
    } else if ($scope.user.n > 1) {
        Toaster.warning("Votre mot de passe expire bientôt, changez le")
    }
    
    $scope.submitForm = function (oldPassword, newPassword, newPassword2) {
        if (!oldPassword || !newPassword) {
            Toaster.danger('Veuillez remplir les champs obligatoires');
            return;
        }
        
        if (!$scope.user) {
            Toaster.danger('Erreur: aucun utilisateur connecté');
            return;
        }
        
        if (oldPassword === newPassword) {
            Toaster.warning('Votre nouveau mot de passe doit être different du mot de passe actuel');
            return;
        }
        
        if (newPassword !== newPassword2) {
            Toaster.warning('Veuillez confirmer votre mot de passe correctement');
            return;
        }
        
        var userId = $scope.user.id;
        UserService.changePassword(userId, oldPassword, newPassword).then(function () {
            Toaster.show('Mot de passe changé avec succès');
            
            LoginService.logout().then(function () {
                $state.go('login');
            })
        }, function (err) {
            Toaster.danger('Echec de la mise à jour du mot de passe');
            console.error(err);
        })
    }
}])